import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@clerk/clerk-react';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers';
import { LIST_PROCESSOR_POOL_QUERY_KEY } from '@/state/queries/processor-admin/use-list-processor-pool';
import { PLATFORM_SUMMARY_QUERY_KEY } from '@/state/queries/ops-admin/use-platform-summary';
import { ATTENTION_QUEUE_QUERY_KEY } from '@/state/queries/ops-admin/use-attention-queue';

export type ResetProcessorResponseDto = {
  requeued: number;
  releasedJobId?: string;
  resetEmitted: boolean;
  warnings?: string[];
};

export function useResetProcessorMutation() {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (playerId: string) => {
      const token = await getToken();
      const url = `${import.meta.env.VITE_API_URL}/processor/players/${encodeURIComponent(playerId)}/reset`;
      return sendJSONRequest({
        url,
        method: METHOD.POST,
        body: {},
        token: token ?? '',
      }) as Promise<ResetProcessorResponseDto>;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [LIST_PROCESSOR_POOL_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [PLATFORM_SUMMARY_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [ATTENTION_QUEUE_QUERY_KEY] });
    },
  });
}
